import { useQuery } from '@tanstack/react-query';
import { ConditionalRender } from '@ui';
import { NotificationTabs } from '@features/components/NotificationTabs';
import { preparePersonalizationSettings } from '@/utils/helpers/notificationsSettings.helpers';
import { personalizationQueries } from '@/queries/communication/personalization/personalization.query';

export const NotificationsSettings = () => {
  const { data: personalizationSettings } = useQuery({
    ...personalizationQueries.all(),
  });

  const preparedSettings = preparePersonalizationSettings(personalizationSettings);
  const categories = preparedSettings?.categories || [];

  return (
    <div className="min-h-full flex flex-1 flex-col gap-5">
      <div className="flex justify-between items-center gap-6 w-full">
        <h1 className="text-3xl">Manage Notifications</h1>
      </div>

      <ConditionalRender show={!!categories.length} placeholder="No notification settings found">
        <NotificationTabs categories={categories} />
      </ConditionalRender>
    </div>
  );
};
